<div
  class="overlay-backdrop-container"
  [ngStyle]="{ top: customTop + 'px', 'z-index': zIndex }"
>
  <div class="overlay-backdrop overlay-dark-backdrop"></div>
</div>
